import script from "./MProfileSocial.vue?vue&type=script&setup=true&lang=js"
export * from "./MProfileSocial.vue?vue&type=script&setup=true&lang=js"

import "./MProfileSocial.vue?vue&type=style&index=0&id=14ed8d50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14ed8d50"]])

export default __exports__